/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowNarrowRight = createReactComponent("outline", "arrow-narrow-right", "IconArrowNarrowRight", [["path", { "d": "M5 12l14 0", "key": "svg-0" }], ["path", { "d": "M15 16l4 -4", "key": "svg-1" }], ["path", { "d": "M15 8l4 4", "key": "svg-2" }]]);

export { IconArrowNarrowRight as default };
//# sourceMappingURL=IconArrowNarrowRight.mjs.map
